import { actionFilms } from "@/mocks/films";

export default function ActionZone() {
  return (
    <section id="action" className="w-full bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-6xl mx-auto">
          <header className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div className="max-w-2xl">
              <span className="inline-flex items-center gap-2 text-xs md:text-sm font-label text-accent-800 bg-accent-100 px-3 py-1.5 rounded-full">
                <i className="ri-boxing-line" aria-hidden="true"></i>
                动作专区
              </span>
              <h2 className="mt-4 font-heading text-2xl md:text-4xl font-black text-foreground-950 leading-snug">
                动作怎么拍，才让人真的屏住呼吸
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                动作片的观赏点不只在打，更在于镜头怎么安排身体与空间。下面几部作品在实拍、喜剧节拍与特技调度上各有侧重。
              </p>
            </div>
            <p className="text-xs md:text-sm text-foreground-500 font-label md:text-right whitespace-nowrap">
              共 {actionFilms.length} 部 · 按年代排列
            </p>
          </header>

          <ol className="mt-10 md:mt-14 space-y-4 md:space-y-5">
            {actionFilms.map((film, index) => (
              <li
                key={film.id}
                className="group flex flex-col sm:flex-row gap-4 md:gap-6 rounded-lg border border-background-200 bg-background-100/70 p-3 md:p-4 hover:border-primary-200 transition-colors"
              >
                <div className="relative shrink-0 w-full sm:w-[150px] md:w-[180px] h-[200px] sm:h-[210px] md:h-[240px] rounded-md overflow-hidden">
                  <img
                    src={film.image}
                    alt={`${film.title} 风格海报插画`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="flex-1 flex flex-col justify-center min-w-0">
                  <div className="flex items-center gap-3">
                    <span className="font-heading text-2xl md:text-3xl font-black text-background-300">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <div className="min-w-0">
                      <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">{film.title}</h3>
                      <p className="text-xs md:text-sm text-foreground-500 font-label mt-0.5">
                        {film.year} · {film.tags.join(" / ")}
                      </p>
                    </div>
                  </div>
                  <p className="mt-3 text-sm md:text-[15px] text-foreground-600 leading-relaxed">{film.note}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}